import {CanvasTextOptions, Container, Graphics, HTMLText, Text} from "pixi.js";
import { DRect } from "src/app/binst/primitives/drawable-rect";
import { Margin } from "src/app/binst/primitives/margin";
import {PixiObject} from "../primitives/pixi-object";

export class TextDrawable extends PixiObject {
  options: CanvasTextOptions;
  __debug = false;
  margin: Margin;
  pixiText: Text;

  constructor(
    options: CanvasTextOptions & {
      margin?: ConstructorParameters<typeof Margin>[0];
    },
  ) {
    super({ id: "text-drawable" });
    if (options.margin instanceof Margin) {
      this.margin = options.margin;
    } else {
      this.margin = new Margin(options.margin ?? {});
    }
    if (this.__debug) {
      const graphics = new Graphics({});
      const rect = new DRect({
        left: 0,
        top: 0,
        right: 500,
        bottom: 500,
        roundness: 10,
        colour: "#0000ff90",
      });
      rect.render(graphics);
      this.sprite.addChild(graphics);
    }
    this.options = options;
    // this.options.resolution = 2
    this.build();
  }

  updateText(text: string) {
    this.options.text = text;
    this.pixiText.text = text;
    // this.build();
  }

  private build() {
    if (this.pixiText) {
      this.sprite.removeChild(this.pixiText);
      this.pixiText.destroy();
    }
    this.pixiText = new Text(this.options);
    this.pixiText.x = this.margin.left;
    this.pixiText.y = this.margin.top;
    this.sprite.width =
      this.pixiText.width + this.margin.right + this.margin.left;
    this.sprite.height =
      this.pixiText.height + this.margin.top + this.margin.bottom;
    this.sprite.addChild(this.pixiText);
  }

  override destroy() {
    super.destroy();
    this.pixiText.destroy();
  }

  set text(text: string) {
    this.pixiText.text = text;
  }

  get text(): string {
    return this.pixiText.text;
  }

  get left(): number {
    return this.sprite.x;
  }

  get top(): number {
    return this.sprite.y;
  }

  get right(): number {
    return (
      this.sprite.x + this.sprite.width + this.margin.right + this.margin.left
    );
  }

  get bottom(): number {
    return (
      this.sprite.y + this.sprite.height + this.margin.bottom + this.margin.top
    );
  }
}
